var _g, _g2, _path, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 305,
    viewBox: "0 0 537 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_32473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 78.9089C94.5689 79.2994 94.2523 79.616 93.8618 79.616C93.4713 79.616 93.1548 79.2994 93.1548 78.9089C93.1548 78.5185 93.4713 78.2019 93.8618 78.2019C94.2523 78.2019 94.5689 78.5185 94.5689 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 78.9089C112.952 79.2994 112.635 79.616 112.245 79.616C111.854 79.616 111.538 79.2994 111.538 78.9089C111.538 78.5185 111.854 78.2019 112.245 78.2019C112.635 78.2019 112.952 78.5185 112.952 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 78.9089C131.335 79.2994 131.018 79.616 130.628 79.616C130.238 79.616 129.921 79.2994 129.921 78.9089C129.921 78.5185 130.238 78.2019 130.628 78.2019C131.018 78.2019 131.335 78.5185 131.335 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 78.9089C149.718 79.2994 149.401 79.616 149.011 79.616C148.62 79.616 148.304 79.2994 148.304 78.9089C148.304 78.5185 148.62 78.2019 149.011 78.2019C149.401 78.2019 149.718 78.5185 149.718 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 78.9089C168.101 79.2994 167.784 79.616 167.394 79.616C167.003 79.616 166.687 79.2994 166.687 78.9089C166.687 78.5185 167.003 78.2019 167.394 78.2019C167.784 78.2019 168.101 78.5185 168.101 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 78.9089C186.483 79.2994 186.167 79.616 185.776 79.616C185.386 79.616 185.069 79.2994 185.069 78.9089C185.069 78.5185 185.386 78.2019 185.776 78.2019C186.167 78.2019 186.483 78.5185 186.483 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 78.9089C204.867 79.2994 204.55 79.616 204.16 79.616C203.769 79.616 203.453 79.2994 203.453 78.9089C203.453 78.5185 203.769 78.2019 204.16 78.2019C204.55 78.2019 204.867 78.5185 204.867 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 78.9089C223.25 79.2994 222.933 79.616 222.542 79.616C222.152 79.616 221.835 79.2994 221.835 78.9089C221.835 78.5185 222.152 78.2019 222.542 78.2019C222.933 78.2019 223.25 78.5185 223.25 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 78.9089C241.632 79.2994 241.316 79.616 240.925 79.616C240.535 79.616 240.218 79.2994 240.218 78.9089C240.218 78.5185 240.535 78.2019 240.925 78.2019C241.316 78.2019 241.632 78.5185 241.632 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 78.9089C260.015 79.2994 259.698 79.616 259.308 79.616C258.918 79.616 258.601 79.2994 258.601 78.9089C258.601 78.5185 258.918 78.2019 259.308 78.2019C259.698 78.2019 260.015 78.5185 260.015 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 97.2918C94.5689 97.6822 94.2523 97.9988 93.8618 97.9988C93.4713 97.9988 93.1548 97.6822 93.1548 97.2918C93.1548 96.9013 93.4713 96.5847 93.8618 96.5847C94.2523 96.5847 94.5689 96.9013 94.5689 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 97.2918C112.952 97.6822 112.635 97.9988 112.245 97.9988C111.854 97.9988 111.538 97.6822 111.538 97.2918C111.538 96.9013 111.854 96.5847 112.245 96.5847C112.635 96.5847 112.952 96.9013 112.952 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 97.2918C131.335 97.6822 131.018 97.9988 130.628 97.9988C130.238 97.9988 129.921 97.6822 129.921 97.2918C129.921 96.9013 130.238 96.5847 130.628 96.5847C131.018 96.5847 131.335 96.9013 131.335 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 97.2918C149.718 97.6822 149.401 97.9988 149.011 97.9988C148.62 97.9988 148.304 97.6822 148.304 97.2918C148.304 96.9013 148.62 96.5847 149.011 96.5847C149.401 96.5847 149.718 96.9013 149.718 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 97.2918C168.101 97.6822 167.784 97.9988 167.394 97.9988C167.003 97.9988 166.687 97.6822 166.687 97.2918C166.687 96.9013 167.003 96.5847 167.394 96.5847C167.784 96.5847 168.101 96.9013 168.101 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 97.2918C186.483 97.6822 186.167 97.9988 185.776 97.9988C185.386 97.9988 185.069 97.6822 185.069 97.2918C185.069 96.9013 185.386 96.5847 185.776 96.5847C186.167 96.5847 186.483 96.9013 186.483 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 97.2918C204.867 97.6822 204.55 97.9988 204.16 97.9988C203.769 97.9988 203.453 97.6822 203.453 97.2918C203.453 96.9013 203.769 96.5847 204.16 96.5847C204.55 96.5847 204.867 96.9013 204.867 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 97.2918C223.25 97.6822 222.933 97.9988 222.542 97.9988C222.152 97.9988 221.835 97.6822 221.835 97.2918C221.835 96.9013 222.152 96.5847 222.542 96.5847C222.933 96.5847 223.25 96.9013 223.25 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 97.2918C241.632 97.6822 241.316 97.9988 240.925 97.9988C240.535 97.9988 240.218 97.6822 240.218 97.2918C240.218 96.9013 240.535 96.5847 240.925 96.5847C241.316 96.5847 241.632 96.9013 241.632 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 97.2918C260.015 97.6822 259.698 97.9988 259.308 97.9988C258.918 97.9988 258.601 97.6822 258.601 97.2918C258.601 96.9013 258.918 96.5847 259.308 96.5847C259.698 96.5847 260.015 96.9013 260.015 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 115.675C94.5689 116.065 94.2523 116.382 93.8618 116.382C93.4713 116.382 93.1548 116.065 93.1548 115.675C93.1548 115.285 93.4713 114.968 93.8618 114.968C94.2523 114.968 94.5689 115.285 94.5689 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 115.675C112.952 116.065 112.635 116.382 112.245 116.382C111.854 116.382 111.538 116.065 111.538 115.675C111.538 115.285 111.854 114.968 112.245 114.968C112.635 114.968 112.952 115.285 112.952 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 115.675C131.335 116.065 131.018 116.382 130.628 116.382C130.238 116.382 129.921 116.065 129.921 115.675C129.921 115.285 130.238 114.968 130.628 114.968C131.018 114.968 131.335 115.285 131.335 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 115.675C149.718 116.065 149.401 116.382 149.011 116.382C148.62 116.382 148.304 116.065 148.304 115.675C148.304 115.285 148.62 114.968 149.011 114.968C149.401 114.968 149.718 115.285 149.718 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 115.675C168.101 116.065 167.784 116.382 167.394 116.382C167.003 116.382 166.687 116.065 166.687 115.675C166.687 115.285 167.003 114.968 167.394 114.968C167.784 114.968 168.101 115.285 168.101 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 115.675C186.483 116.065 186.167 116.382 185.776 116.382C185.386 116.382 185.069 116.065 185.069 115.675C185.069 115.285 185.386 114.968 185.776 114.968C186.167 114.968 186.483 115.285 186.483 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 115.675C204.867 116.065 204.55 116.382 204.16 116.382C203.769 116.382 203.453 116.065 203.453 115.675C203.453 115.285 203.769 114.968 204.16 114.968C204.55 114.968 204.867 115.285 204.867 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 115.675C223.25 116.065 222.933 116.382 222.542 116.382C222.152 116.382 221.835 116.065 221.835 115.675C221.835 115.285 222.152 114.968 222.542 114.968C222.933 114.968 223.25 115.285 223.25 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 115.675C241.632 116.065 241.316 116.382 240.925 116.382C240.535 116.382 240.218 116.065 240.218 115.675C240.218 115.285 240.535 114.968 240.925 114.968C241.316 114.968 241.632 115.285 241.632 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 115.675C260.015 116.065 259.698 116.382 259.308 116.382C258.918 116.382 258.601 116.065 258.601 115.675C258.601 115.285 258.918 114.968 259.308 114.968C259.698 114.968 260.015 115.285 260.015 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 134.058C94.5689 134.448 94.2523 134.765 93.8618 134.765C93.4713 134.765 93.1548 134.448 93.1548 134.058C93.1548 133.667 93.4713 133.351 93.8618 133.351C94.2523 133.351 94.5689 133.667 94.5689 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 134.058C112.952 134.448 112.635 134.765 112.245 134.765C111.854 134.765 111.538 134.448 111.538 134.058C111.538 133.667 111.854 133.351 112.245 133.351C112.635 133.351 112.952 133.667 112.952 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 134.058C131.335 134.448 131.018 134.765 130.628 134.765C130.238 134.765 129.921 134.448 129.921 134.058C129.921 133.667 130.238 133.351 130.628 133.351C131.018 133.351 131.335 133.667 131.335 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 134.058C149.718 134.448 149.401 134.765 149.011 134.765C148.62 134.765 148.304 134.448 148.304 134.058C148.304 133.667 148.62 133.351 149.011 133.351C149.401 133.351 149.718 133.667 149.718 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 134.058C168.101 134.448 167.784 134.765 167.394 134.765C167.003 134.765 166.687 134.448 166.687 134.058C166.687 133.667 167.003 133.351 167.394 133.351C167.784 133.351 168.101 133.667 168.101 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 134.058C186.483 134.448 186.167 134.765 185.776 134.765C185.386 134.765 185.069 134.448 185.069 134.058C185.069 133.667 185.386 133.351 185.776 133.351C186.167 133.351 186.483 133.667 186.483 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 134.058C204.867 134.448 204.55 134.765 204.16 134.765C203.769 134.765 203.453 134.448 203.453 134.058C203.453 133.667 203.769 133.351 204.16 133.351C204.55 133.351 204.867 133.667 204.867 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 134.058C223.25 134.448 222.933 134.765 222.542 134.765C222.152 134.765 221.835 134.448 221.835 134.058C221.835 133.667 222.152 133.351 222.542 133.351C222.933 133.351 223.25 133.667 223.25 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 134.058C241.632 134.448 241.316 134.765 240.925 134.765C240.535 134.765 240.218 134.448 240.218 134.058C240.218 133.667 240.535 133.351 240.925 133.351C241.316 133.351 241.632 133.667 241.632 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 134.058C260.015 134.448 259.698 134.765 259.308 134.765C258.918 134.765 258.601 134.448 258.601 134.058C258.601 133.667 258.918 133.351 259.308 133.351C259.698 133.351 260.015 133.667 260.015 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 152.441C94.5689 152.831 94.2523 153.148 93.8618 153.148C93.4713 153.148 93.1548 152.831 93.1548 152.441C93.1548 152.05 93.4713 151.734 93.8618 151.734C94.2523 151.734 94.5689 152.05 94.5689 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 152.441C112.952 152.831 112.635 153.148 112.245 153.148C111.854 153.148 111.538 152.831 111.538 152.441C111.538 152.05 111.854 151.734 112.245 151.734C112.635 151.734 112.952 152.05 112.952 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 152.441C131.335 152.831 131.018 153.148 130.628 153.148C130.238 153.148 129.921 152.831 129.921 152.441C129.921 152.05 130.238 151.734 130.628 151.734C131.018 151.734 131.335 152.05 131.335 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 152.441C149.718 152.831 149.401 153.148 149.011 153.148C148.62 153.148 148.304 152.831 148.304 152.441C148.304 152.05 148.62 151.734 149.011 151.734C149.401 151.734 149.718 152.05 149.718 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 152.441C168.101 152.831 167.784 153.148 167.394 153.148C167.003 153.148 166.687 152.831 166.687 152.441C166.687 152.05 167.003 151.734 167.394 151.734C167.784 151.734 168.101 152.05 168.101 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 152.441C186.483 152.831 186.167 153.148 185.776 153.148C185.386 153.148 185.069 152.831 185.069 152.441C185.069 152.05 185.386 151.734 185.776 151.734C186.167 151.734 186.483 152.05 186.483 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 152.441C204.867 152.831 204.55 153.148 204.16 153.148C203.769 153.148 203.453 152.831 203.453 152.441C203.453 152.05 203.769 151.734 204.16 151.734C204.55 151.734 204.867 152.05 204.867 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 152.441C223.25 152.831 222.933 153.148 222.542 153.148C222.152 153.148 221.835 152.831 221.835 152.441C221.835 152.05 222.152 151.734 222.542 151.734C222.933 151.734 223.25 152.05 223.25 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 152.441C241.632 152.831 241.316 153.148 240.925 153.148C240.535 153.148 240.218 152.831 240.218 152.441C240.218 152.05 240.535 151.734 240.925 151.734C241.316 151.734 241.632 152.05 241.632 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 152.441C260.015 152.831 259.698 153.148 259.308 153.148C258.918 153.148 258.601 152.831 258.601 152.441C258.601 152.05 258.918 151.734 259.308 151.734C259.698 151.734 260.015 152.05 260.015 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 170.824C94.5689 171.214 94.2523 171.531 93.8618 171.531C93.4713 171.531 93.1548 171.214 93.1548 170.824C93.1548 170.433 93.4713 170.117 93.8618 170.117C94.2523 170.117 94.5689 170.433 94.5689 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 170.824C112.952 171.214 112.635 171.531 112.245 171.531C111.854 171.531 111.538 171.214 111.538 170.824C111.538 170.433 111.854 170.117 112.245 170.117C112.635 170.117 112.952 170.433 112.952 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 170.824C131.335 171.214 131.018 171.531 130.628 171.531C130.238 171.531 129.921 171.214 129.921 170.824C129.921 170.433 130.238 170.117 130.628 170.117C131.018 170.117 131.335 170.433 131.335 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 170.824C149.718 171.214 149.401 171.531 149.011 171.531C148.62 171.531 148.304 171.214 148.304 170.824C148.304 170.433 148.62 170.117 149.011 170.117C149.401 170.117 149.718 170.433 149.718 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 170.824C168.101 171.214 167.784 171.531 167.394 171.531C167.003 171.531 166.687 171.214 166.687 170.824C166.687 170.433 167.003 170.117 167.394 170.117C167.784 170.117 168.101 170.433 168.101 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 170.824C186.483 171.214 186.167 171.531 185.776 171.531C185.386 171.531 185.069 171.214 185.069 170.824C185.069 170.433 185.386 170.117 185.776 170.117C186.167 170.117 186.483 170.433 186.483 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 170.824C204.867 171.214 204.55 171.531 204.16 171.531C203.769 171.531 203.453 171.214 203.453 170.824C203.453 170.433 203.769 170.117 204.16 170.117C204.55 170.117 204.867 170.433 204.867 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 170.824C223.25 171.214 222.933 171.531 222.542 171.531C222.152 171.531 221.835 171.214 221.835 170.824C221.835 170.433 222.152 170.117 222.542 170.117C222.933 170.117 223.25 170.433 223.25 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 170.824C241.632 171.214 241.316 171.531 240.925 171.531C240.535 171.531 240.218 171.214 240.218 170.824C240.218 170.433 240.535 170.117 240.925 170.117C241.316 170.117 241.632 170.433 241.632 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 170.824C260.015 171.214 259.698 171.531 259.308 171.531C258.918 171.531 258.601 171.214 258.601 170.824C258.601 170.433 258.918 170.117 259.308 170.117C259.698 170.117 260.015 170.433 260.015 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 189.207C94.5689 189.597 94.2523 189.914 93.8618 189.914C93.4713 189.914 93.1548 189.597 93.1548 189.207C93.1548 188.816 93.4713 188.5 93.8618 188.5C94.2523 188.5 94.5689 188.816 94.5689 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 189.207C112.952 189.597 112.635 189.914 112.245 189.914C111.854 189.914 111.538 189.597 111.538 189.207C111.538 188.816 111.854 188.5 112.245 188.5C112.635 188.5 112.952 188.816 112.952 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 189.207C131.335 189.597 131.018 189.914 130.628 189.914C130.238 189.914 129.921 189.597 129.921 189.207C129.921 188.816 130.238 188.5 130.628 188.5C131.018 188.5 131.335 188.816 131.335 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 189.207C149.718 189.597 149.401 189.914 149.011 189.914C148.62 189.914 148.304 189.597 148.304 189.207C148.304 188.816 148.62 188.5 149.011 188.5C149.401 188.5 149.718 188.816 149.718 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 189.207C168.101 189.597 167.784 189.914 167.394 189.914C167.003 189.914 166.687 189.597 166.687 189.207C166.687 188.816 167.003 188.5 167.394 188.5C167.784 188.5 168.101 188.816 168.101 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 189.207C186.483 189.597 186.167 189.914 185.776 189.914C185.386 189.914 185.069 189.597 185.069 189.207C185.069 188.816 185.386 188.5 185.776 188.5C186.167 188.5 186.483 188.816 186.483 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 189.207C204.867 189.597 204.55 189.914 204.16 189.914C203.769 189.914 203.453 189.597 203.453 189.207C203.453 188.816 203.769 188.5 204.16 188.5C204.55 188.5 204.867 188.816 204.867 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 189.207C223.25 189.597 222.933 189.914 222.542 189.914C222.152 189.914 221.835 189.597 221.835 189.207C221.835 188.816 222.152 188.5 222.542 188.5C222.933 188.5 223.25 188.816 223.25 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 189.207C241.632 189.597 241.316 189.914 240.925 189.914C240.535 189.914 240.218 189.597 240.218 189.207C240.218 188.816 240.535 188.5 240.925 188.5C241.316 188.5 241.632 188.816 241.632 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 189.207C260.015 189.597 259.698 189.914 259.308 189.914C258.918 189.914 258.601 189.597 258.601 189.207C258.601 188.816 258.918 188.5 259.308 188.5C259.698 188.5 260.015 188.816 260.015 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 207.589C94.5689 207.98 94.2523 208.296 93.8618 208.296C93.4713 208.296 93.1548 207.98 93.1548 207.589C93.1548 207.199 93.4713 206.882 93.8618 206.882C94.2523 206.882 94.5689 207.199 94.5689 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 207.589C112.952 207.98 112.635 208.296 112.245 208.296C111.854 208.296 111.538 207.98 111.538 207.589C111.538 207.199 111.854 206.882 112.245 206.882C112.635 206.882 112.952 207.199 112.952 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 207.589C131.335 207.98 131.018 208.296 130.628 208.296C130.238 208.296 129.921 207.98 129.921 207.589C129.921 207.199 130.238 206.882 130.628 206.882C131.018 206.882 131.335 207.199 131.335 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 207.589C149.718 207.98 149.401 208.296 149.011 208.296C148.62 208.296 148.304 207.98 148.304 207.589C148.304 207.199 148.62 206.882 149.011 206.882C149.401 206.882 149.718 207.199 149.718 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 207.589C168.101 207.98 167.784 208.296 167.394 208.296C167.003 208.296 166.687 207.98 166.687 207.589C166.687 207.199 167.003 206.882 167.394 206.882C167.784 206.882 168.101 207.199 168.101 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 207.589C186.483 207.98 186.167 208.296 185.776 208.296C185.386 208.296 185.069 207.98 185.069 207.589C185.069 207.199 185.386 206.882 185.776 206.882C186.167 206.882 186.483 207.199 186.483 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 207.589C204.867 207.98 204.55 208.296 204.16 208.296C203.769 208.296 203.453 207.98 203.453 207.589C203.453 207.199 203.769 206.882 204.16 206.882C204.55 206.882 204.867 207.199 204.867 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 207.589C223.25 207.98 222.933 208.296 222.542 208.296C222.152 208.296 221.835 207.98 221.835 207.589C221.835 207.199 222.152 206.882 222.542 206.882C222.933 206.882 223.25 207.199 223.25 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 207.589C241.632 207.98 241.316 208.296 240.925 208.296C240.535 208.296 240.218 207.98 240.218 207.589C240.218 207.199 240.535 206.882 240.925 206.882C241.316 206.882 241.632 207.199 241.632 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 207.589C260.015 207.98 259.698 208.296 259.308 208.296C258.918 208.296 258.601 207.98 258.601 207.589C258.601 207.199 258.918 206.882 259.308 206.882C259.698 206.882 260.015 207.199 260.015 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 225.973C94.5689 226.363 94.2523 226.68 93.8618 226.68C93.4713 226.68 93.1548 226.363 93.1548 225.973C93.1548 225.582 93.4713 225.266 93.8618 225.266C94.2523 225.266 94.5689 225.582 94.5689 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 225.973C112.952 226.363 112.635 226.68 112.245 226.68C111.854 226.68 111.538 226.363 111.538 225.973C111.538 225.582 111.854 225.266 112.245 225.266C112.635 225.266 112.952 225.582 112.952 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 225.973C131.335 226.363 131.018 226.68 130.628 226.68C130.238 226.68 129.921 226.363 129.921 225.973C129.921 225.582 130.238 225.266 130.628 225.266C131.018 225.266 131.335 225.582 131.335 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 225.973C149.718 226.363 149.401 226.68 149.011 226.68C148.62 226.68 148.304 226.363 148.304 225.973C148.304 225.582 148.62 225.266 149.011 225.266C149.401 225.266 149.718 225.582 149.718 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 225.973C168.101 226.363 167.784 226.68 167.394 226.68C167.003 226.68 166.687 226.363 166.687 225.973C166.687 225.582 167.003 225.266 167.394 225.266C167.784 225.266 168.101 225.582 168.101 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 225.973C186.483 226.363 186.167 226.68 185.776 226.68C185.386 226.68 185.069 226.363 185.069 225.973C185.069 225.582 185.386 225.266 185.776 225.266C186.167 225.266 186.483 225.582 186.483 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 225.973C204.867 226.363 204.55 226.68 204.16 226.68C203.769 226.68 203.453 226.363 203.453 225.973C203.453 225.582 203.769 225.266 204.16 225.266C204.55 225.266 204.867 225.582 204.867 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 225.973C223.25 226.363 222.933 226.68 222.542 226.68C222.152 226.68 221.835 226.363 221.835 225.973C221.835 225.582 222.152 225.266 222.542 225.266C222.933 225.266 223.25 225.582 223.25 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 225.973C241.632 226.363 241.316 226.68 240.925 226.68C240.535 226.68 240.218 226.363 240.218 225.973C240.218 225.582 240.535 225.266 240.925 225.266C241.316 225.266 241.632 225.582 241.632 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 225.973C260.015 226.363 259.698 226.68 259.308 226.68C258.918 226.68 258.601 226.363 258.601 225.973C258.601 225.582 258.918 225.266 259.308 225.266C259.698 225.266 260.015 225.582 260.015 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 244.355C94.5689 244.746 94.2523 245.063 93.8618 245.063C93.4713 245.063 93.1548 244.746 93.1548 244.355C93.1548 243.965 93.4713 243.648 93.8618 243.648C94.2523 243.648 94.5689 243.965 94.5689 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 244.355C112.952 244.746 112.635 245.063 112.245 245.063C111.854 245.063 111.538 244.746 111.538 244.355C111.538 243.965 111.854 243.648 112.245 243.648C112.635 243.648 112.952 243.965 112.952 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 244.355C131.335 244.746 131.018 245.063 130.628 245.063C130.238 245.063 129.921 244.746 129.921 244.355C129.921 243.965 130.238 243.648 130.628 243.648C131.018 243.648 131.335 243.965 131.335 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 244.355C149.718 244.746 149.401 245.063 149.011 245.063C148.62 245.063 148.304 244.746 148.304 244.355C148.304 243.965 148.62 243.648 149.011 243.648C149.401 243.648 149.718 243.965 149.718 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 244.355C168.101 244.746 167.784 245.063 167.394 245.063C167.003 245.063 166.687 244.746 166.687 244.355C166.687 243.965 167.003 243.648 167.394 243.648C167.784 243.648 168.101 243.965 168.101 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 244.355C186.483 244.746 186.167 245.063 185.776 245.063C185.386 245.063 185.069 244.746 185.069 244.355C185.069 243.965 185.386 243.648 185.776 243.648C186.167 243.648 186.483 243.965 186.483 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 244.355C204.867 244.746 204.55 245.063 204.16 245.063C203.769 245.063 203.453 244.746 203.453 244.355C203.453 243.965 203.769 243.648 204.16 243.648C204.55 243.648 204.867 243.965 204.867 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 244.355C223.25 244.746 222.933 245.063 222.542 245.063C222.152 245.063 221.835 244.746 221.835 244.355C221.835 243.965 222.152 243.648 222.542 243.648C222.933 243.648 223.25 243.965 223.25 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 244.355C241.632 244.746 241.316 245.063 240.925 245.063C240.535 245.063 240.218 244.746 240.218 244.355C240.218 243.965 240.535 243.648 240.925 243.648C241.316 243.648 241.632 243.965 241.632 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 244.355C260.015 244.746 259.698 245.063 259.308 245.063C258.918 245.063 258.601 244.746 258.601 244.355C258.601 243.965 258.918 243.648 259.308 243.648C259.698 243.648 260.015 243.965 260.015 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 262.739C94.5689 263.129 94.2523 263.446 93.8618 263.446C93.4713 263.446 93.1548 263.129 93.1548 262.739C93.1548 262.348 93.4713 262.031 93.8618 262.031C94.2523 262.031 94.5689 262.348 94.5689 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 262.739C112.952 263.129 112.635 263.446 112.245 263.446C111.854 263.446 111.538 263.129 111.538 262.739C111.538 262.348 111.854 262.031 112.245 262.031C112.635 262.031 112.952 262.348 112.952 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 262.739C131.335 263.129 131.018 263.446 130.628 263.446C130.238 263.446 129.921 263.129 129.921 262.739C129.921 262.348 130.238 262.031 130.628 262.031C131.018 262.031 131.335 262.348 131.335 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 262.739C149.718 263.129 149.401 263.446 149.011 263.446C148.62 263.446 148.304 263.129 148.304 262.739C148.304 262.348 148.62 262.031 149.011 262.031C149.401 262.031 149.718 262.348 149.718 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 262.739C168.101 263.129 167.784 263.446 167.394 263.446C167.003 263.446 166.687 263.129 166.687 262.739C166.687 262.348 167.003 262.031 167.394 262.031C167.784 262.031 168.101 262.348 168.101 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 262.739C186.483 263.129 186.167 263.446 185.776 263.446C185.386 263.446 185.069 263.129 185.069 262.739C185.069 262.348 185.386 262.031 185.776 262.031C186.167 262.031 186.483 262.348 186.483 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 262.739C204.867 263.129 204.55 263.446 204.16 263.446C203.769 263.446 203.453 263.129 203.453 262.739C203.453 262.348 203.769 262.031 204.16 262.031C204.55 262.031 204.867 262.348 204.867 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 262.739C223.25 263.129 222.933 263.446 222.542 263.446C222.152 263.446 221.835 263.129 221.835 262.739C221.835 262.348 222.152 262.031 222.542 262.031C222.933 262.031 223.25 262.348 223.25 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 262.739C241.632 263.129 241.316 263.446 240.925 263.446C240.535 263.446 240.218 263.129 240.218 262.739C240.218 262.348 240.535 262.031 240.925 262.031C241.316 262.031 241.632 262.348 241.632 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 262.739C260.015 263.129 259.698 263.446 259.308 263.446C258.918 263.446 258.601 263.129 258.601 262.739C258.601 262.348 258.918 262.031 259.308 262.031C259.698 262.031 260.015 262.348 260.015 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 281.121C94.5689 281.512 94.2523 281.828 93.8618 281.828C93.4713 281.828 93.1548 281.512 93.1548 281.121C93.1548 280.731 93.4713 280.414 93.8618 280.414C94.2523 280.414 94.5689 280.731 94.5689 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 281.121C112.952 281.512 112.635 281.828 112.245 281.828C111.854 281.828 111.538 281.512 111.538 281.121C111.538 280.731 111.854 280.414 112.245 280.414C112.635 280.414 112.952 280.731 112.952 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 281.121C131.335 281.512 131.018 281.828 130.628 281.828C130.238 281.828 129.921 281.512 129.921 281.121C129.921 280.731 130.238 280.414 130.628 280.414C131.018 280.414 131.335 280.731 131.335 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 281.121C149.718 281.512 149.401 281.828 149.011 281.828C148.62 281.828 148.304 281.512 148.304 281.121C148.304 280.731 148.62 280.414 149.011 280.414C149.401 280.414 149.718 280.731 149.718 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 281.121C168.101 281.512 167.784 281.828 167.394 281.828C167.003 281.828 166.687 281.512 166.687 281.121C166.687 280.731 167.003 280.414 167.394 280.414C167.784 280.414 168.101 280.731 168.101 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 281.121C186.483 281.512 186.167 281.828 185.776 281.828C185.386 281.828 185.069 281.512 185.069 281.121C185.069 280.731 185.386 280.414 185.776 280.414C186.167 280.414 186.483 280.731 186.483 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 281.121C204.867 281.512 204.55 281.828 204.16 281.828C203.769 281.828 203.453 281.512 203.453 281.121C203.453 280.731 203.769 280.414 204.16 280.414C204.55 280.414 204.867 280.731 204.867 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 281.121C223.25 281.512 222.933 281.828 222.542 281.828C222.152 281.828 221.835 281.512 221.835 281.121C221.835 280.731 222.152 280.414 222.542 280.414C222.933 280.414 223.25 280.731 223.25 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 281.121C241.632 281.512 241.316 281.828 240.925 281.828C240.535 281.828 240.218 281.512 240.218 281.121C240.218 280.731 240.535 280.414 240.925 280.414C241.316 280.414 241.632 280.731 241.632 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 281.121C260.015 281.512 259.698 281.828 259.308 281.828C258.918 281.828 258.601 281.512 258.601 281.121C258.601 280.731 258.918 280.414 259.308 280.414C259.698 280.414 260.015 280.731 260.015 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5689 299.504C94.5689 299.895 94.2523 300.211 93.8618 300.211C93.4713 300.211 93.1548 299.895 93.1548 299.504C93.1548 299.114 93.4713 298.797 93.8618 298.797C94.2523 298.797 94.5689 299.114 94.5689 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.952 299.504C112.952 299.895 112.635 300.211 112.245 300.211C111.854 300.211 111.538 299.895 111.538 299.504C111.538 299.114 111.854 298.797 112.245 298.797C112.635 298.797 112.952 299.114 112.952 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.335 299.504C131.335 299.895 131.018 300.211 130.628 300.211C130.238 300.211 129.921 299.895 129.921 299.504C129.921 299.114 130.238 298.797 130.628 298.797C131.018 298.797 131.335 299.114 131.335 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.718 299.504C149.718 299.895 149.401 300.211 149.011 300.211C148.62 300.211 148.304 299.895 148.304 299.504C148.304 299.114 148.62 298.797 149.011 298.797C149.401 298.797 149.718 299.114 149.718 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.101 299.504C168.101 299.895 167.784 300.211 167.394 300.211C167.003 300.211 166.687 299.895 166.687 299.504C166.687 299.114 167.003 298.797 167.394 298.797C167.784 298.797 168.101 299.114 168.101 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.483 299.504C186.483 299.895 186.167 300.211 185.776 300.211C185.386 300.211 185.069 299.895 185.069 299.504C185.069 299.114 185.386 298.797 185.776 298.797C186.167 298.797 186.483 299.114 186.483 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.867 299.504C204.867 299.895 204.55 300.211 204.16 300.211C203.769 300.211 203.453 299.895 203.453 299.504C203.453 299.114 203.769 298.797 204.16 298.797C204.55 298.797 204.867 299.114 204.867 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.25 299.504C223.25 299.895 222.933 300.211 222.542 300.211C222.152 300.211 221.835 299.895 221.835 299.504C221.835 299.114 222.152 298.797 222.542 298.797C222.933 298.797 223.25 299.114 223.25 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.632 299.504C241.632 299.895 241.316 300.211 240.925 300.211C240.535 300.211 240.218 299.895 240.218 299.504C240.218 299.114 240.535 298.797 240.925 298.797C241.316 298.797 241.632 299.114 241.632 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.015 299.504C260.015 299.895 259.698 300.211 259.308 300.211C258.918 300.211 258.601 299.895 258.601 299.504C258.601 299.114 258.918 298.797 259.308 298.797C259.698 298.797 260.015 299.114 260.015 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 78.9089C442.431 79.2994 442.747 79.616 443.138 79.616C443.528 79.616 443.845 79.2994 443.845 78.9089C443.845 78.5185 443.528 78.2019 443.138 78.2019C442.747 78.2019 442.431 78.5185 442.431 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 78.9089C424.048 79.2994 424.365 79.616 424.755 79.616C425.145 79.616 425.462 79.2994 425.462 78.9089C425.462 78.5185 425.145 78.2019 424.755 78.2019C424.365 78.2019 424.048 78.5185 424.048 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 78.9089C405.665 79.2994 405.982 79.616 406.372 79.616C406.762 79.616 407.079 79.2994 407.079 78.9089C407.079 78.5185 406.762 78.2019 406.372 78.2019C405.982 78.2019 405.665 78.5185 405.665 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 78.9089C387.282 79.2994 387.598 79.616 387.989 79.616C388.379 79.616 388.696 79.2994 388.696 78.9089C388.696 78.5185 388.379 78.2019 387.989 78.2019C387.598 78.2019 387.282 78.5185 387.282 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 78.9089C368.899 79.2994 369.216 79.616 369.606 79.616C369.996 79.616 370.313 79.2994 370.313 78.9089C370.313 78.5185 369.996 78.2019 369.606 78.2019C369.216 78.2019 368.899 78.5185 368.899 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 78.9089C350.516 79.2994 350.833 79.616 351.223 79.616C351.613 79.616 351.93 79.2994 351.93 78.9089C351.93 78.5185 351.613 78.2019 351.223 78.2019C350.833 78.2019 350.516 78.5185 350.516 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 78.9089C332.133 79.2994 332.45 79.616 332.84 79.616C333.231 79.616 333.547 79.2994 333.547 78.9089C333.547 78.5185 333.231 78.2019 332.84 78.2019C332.45 78.2019 332.133 78.5185 332.133 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 78.9089C313.75 79.2994 314.067 79.616 314.457 79.616C314.847 79.616 315.164 79.2994 315.164 78.9089C315.164 78.5185 314.847 78.2019 314.457 78.2019C314.067 78.2019 313.75 78.5185 313.75 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 78.9089C295.367 79.2994 295.684 79.616 296.074 79.616C296.465 79.616 296.781 79.2994 296.781 78.9089C296.781 78.5185 296.465 78.2019 296.074 78.2019C295.684 78.2019 295.367 78.5185 295.367 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 78.9089C276.984 79.2994 277.301 79.616 277.691 79.616C278.082 79.616 278.398 79.2994 278.398 78.9089C278.398 78.5185 278.082 78.2019 277.691 78.2019C277.301 78.2019 276.984 78.5185 276.984 78.9089Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 97.2918C442.431 97.6822 442.747 97.9988 443.138 97.9988C443.528 97.9988 443.845 97.6822 443.845 97.2918C443.845 96.9013 443.528 96.5847 443.138 96.5847C442.747 96.5847 442.431 96.9013 442.431 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 97.2918C424.048 97.6822 424.365 97.9988 424.755 97.9988C425.145 97.9988 425.462 97.6822 425.462 97.2918C425.462 96.9013 425.145 96.5847 424.755 96.5847C424.365 96.5847 424.048 96.9013 424.048 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 97.2918C405.665 97.6822 405.982 97.9988 406.372 97.9988C406.762 97.9988 407.079 97.6822 407.079 97.2918C407.079 96.9013 406.762 96.5847 406.372 96.5847C405.982 96.5847 405.665 96.9013 405.665 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 97.2918C387.282 97.6822 387.598 97.9988 387.989 97.9988C388.379 97.9988 388.696 97.6822 388.696 97.2918C388.696 96.9013 388.379 96.5847 387.989 96.5847C387.598 96.5847 387.282 96.9013 387.282 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 97.2918C368.899 97.6822 369.216 97.9988 369.606 97.9988C369.996 97.9988 370.313 97.6822 370.313 97.2918C370.313 96.9013 369.996 96.5847 369.606 96.5847C369.216 96.5847 368.899 96.9013 368.899 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 97.2918C350.516 97.6822 350.833 97.9988 351.223 97.9988C351.613 97.9988 351.93 97.6822 351.93 97.2918C351.93 96.9013 351.613 96.5847 351.223 96.5847C350.833 96.5847 350.516 96.9013 350.516 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 97.2918C332.133 97.6822 332.45 97.9988 332.84 97.9988C333.231 97.9988 333.547 97.6822 333.547 97.2918C333.547 96.9013 333.231 96.5847 332.84 96.5847C332.45 96.5847 332.133 96.9013 332.133 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 97.2918C313.75 97.6822 314.067 97.9988 314.457 97.9988C314.847 97.9988 315.164 97.6822 315.164 97.2918C315.164 96.9013 314.847 96.5847 314.457 96.5847C314.067 96.5847 313.75 96.9013 313.75 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 97.2918C295.367 97.6822 295.684 97.9988 296.074 97.9988C296.465 97.9988 296.781 97.6822 296.781 97.2918C296.781 96.9013 296.465 96.5847 296.074 96.5847C295.684 96.5847 295.367 96.9013 295.367 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 97.2918C276.984 97.6822 277.301 97.9988 277.691 97.9988C278.082 97.9988 278.398 97.6822 278.398 97.2918C278.398 96.9013 278.082 96.5847 277.691 96.5847C277.301 96.5847 276.984 96.9013 276.984 97.2918Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 115.675C442.431 116.065 442.747 116.382 443.138 116.382C443.528 116.382 443.845 116.065 443.845 115.675C443.845 115.285 443.528 114.968 443.138 114.968C442.747 114.968 442.431 115.285 442.431 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 115.675C424.048 116.065 424.365 116.382 424.755 116.382C425.145 116.382 425.462 116.065 425.462 115.675C425.462 115.285 425.145 114.968 424.755 114.968C424.365 114.968 424.048 115.285 424.048 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 115.675C405.665 116.065 405.982 116.382 406.372 116.382C406.762 116.382 407.079 116.065 407.079 115.675C407.079 115.285 406.762 114.968 406.372 114.968C405.982 114.968 405.665 115.285 405.665 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 115.675C387.282 116.065 387.598 116.382 387.989 116.382C388.379 116.382 388.696 116.065 388.696 115.675C388.696 115.285 388.379 114.968 387.989 114.968C387.598 114.968 387.282 115.285 387.282 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 115.675C368.899 116.065 369.216 116.382 369.606 116.382C369.996 116.382 370.313 116.065 370.313 115.675C370.313 115.285 369.996 114.968 369.606 114.968C369.216 114.968 368.899 115.285 368.899 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 115.675C350.516 116.065 350.833 116.382 351.223 116.382C351.613 116.382 351.93 116.065 351.93 115.675C351.93 115.285 351.613 114.968 351.223 114.968C350.833 114.968 350.516 115.285 350.516 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 115.675C332.133 116.065 332.45 116.382 332.84 116.382C333.231 116.382 333.547 116.065 333.547 115.675C333.547 115.285 333.231 114.968 332.84 114.968C332.45 114.968 332.133 115.285 332.133 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 115.675C313.75 116.065 314.067 116.382 314.457 116.382C314.847 116.382 315.164 116.065 315.164 115.675C315.164 115.285 314.847 114.968 314.457 114.968C314.067 114.968 313.75 115.285 313.75 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 115.675C295.367 116.065 295.684 116.382 296.074 116.382C296.465 116.382 296.781 116.065 296.781 115.675C296.781 115.285 296.465 114.968 296.074 114.968C295.684 114.968 295.367 115.285 295.367 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 115.675C276.984 116.065 277.301 116.382 277.691 116.382C278.082 116.382 278.398 116.065 278.398 115.675C278.398 115.285 278.082 114.968 277.691 114.968C277.301 114.968 276.984 115.285 276.984 115.675Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 134.058C442.431 134.448 442.747 134.765 443.138 134.765C443.528 134.765 443.845 134.448 443.845 134.058C443.845 133.667 443.528 133.351 443.138 133.351C442.747 133.351 442.431 133.667 442.431 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 134.058C424.048 134.448 424.365 134.765 424.755 134.765C425.145 134.765 425.462 134.448 425.462 134.058C425.462 133.667 425.145 133.351 424.755 133.351C424.365 133.351 424.048 133.667 424.048 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 134.058C405.665 134.448 405.982 134.765 406.372 134.765C406.762 134.765 407.079 134.448 407.079 134.058C407.079 133.667 406.762 133.351 406.372 133.351C405.982 133.351 405.665 133.667 405.665 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 134.058C387.282 134.448 387.598 134.765 387.989 134.765C388.379 134.765 388.696 134.448 388.696 134.058C388.696 133.667 388.379 133.351 387.989 133.351C387.598 133.351 387.282 133.667 387.282 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 134.058C368.899 134.448 369.216 134.765 369.606 134.765C369.996 134.765 370.313 134.448 370.313 134.058C370.313 133.667 369.996 133.351 369.606 133.351C369.216 133.351 368.899 133.667 368.899 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 134.058C350.516 134.448 350.833 134.765 351.223 134.765C351.613 134.765 351.93 134.448 351.93 134.058C351.93 133.667 351.613 133.351 351.223 133.351C350.833 133.351 350.516 133.667 350.516 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 134.058C332.133 134.448 332.45 134.765 332.84 134.765C333.231 134.765 333.547 134.448 333.547 134.058C333.547 133.667 333.231 133.351 332.84 133.351C332.45 133.351 332.133 133.667 332.133 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 134.058C313.75 134.448 314.067 134.765 314.457 134.765C314.847 134.765 315.164 134.448 315.164 134.058C315.164 133.667 314.847 133.351 314.457 133.351C314.067 133.351 313.75 133.667 313.75 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 134.058C295.367 134.448 295.684 134.765 296.074 134.765C296.465 134.765 296.781 134.448 296.781 134.058C296.781 133.667 296.465 133.351 296.074 133.351C295.684 133.351 295.367 133.667 295.367 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 134.058C276.984 134.448 277.301 134.765 277.691 134.765C278.082 134.765 278.398 134.448 278.398 134.058C278.398 133.667 278.082 133.351 277.691 133.351C277.301 133.351 276.984 133.667 276.984 134.058Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 152.441C442.431 152.831 442.747 153.148 443.138 153.148C443.528 153.148 443.845 152.831 443.845 152.441C443.845 152.05 443.528 151.734 443.138 151.734C442.747 151.734 442.431 152.05 442.431 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 152.441C424.048 152.831 424.365 153.148 424.755 153.148C425.145 153.148 425.462 152.831 425.462 152.441C425.462 152.05 425.145 151.734 424.755 151.734C424.365 151.734 424.048 152.05 424.048 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 152.441C405.665 152.831 405.982 153.148 406.372 153.148C406.762 153.148 407.079 152.831 407.079 152.441C407.079 152.05 406.762 151.734 406.372 151.734C405.982 151.734 405.665 152.05 405.665 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 152.441C387.282 152.831 387.598 153.148 387.989 153.148C388.379 153.148 388.696 152.831 388.696 152.441C388.696 152.05 388.379 151.734 387.989 151.734C387.598 151.734 387.282 152.05 387.282 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 152.441C368.899 152.831 369.216 153.148 369.606 153.148C369.996 153.148 370.313 152.831 370.313 152.441C370.313 152.05 369.996 151.734 369.606 151.734C369.216 151.734 368.899 152.05 368.899 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 152.441C350.516 152.831 350.833 153.148 351.223 153.148C351.613 153.148 351.93 152.831 351.93 152.441C351.93 152.05 351.613 151.734 351.223 151.734C350.833 151.734 350.516 152.05 350.516 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 152.441C332.133 152.831 332.45 153.148 332.84 153.148C333.231 153.148 333.547 152.831 333.547 152.441C333.547 152.05 333.231 151.734 332.84 151.734C332.45 151.734 332.133 152.05 332.133 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 152.441C313.75 152.831 314.067 153.148 314.457 153.148C314.847 153.148 315.164 152.831 315.164 152.441C315.164 152.05 314.847 151.734 314.457 151.734C314.067 151.734 313.75 152.05 313.75 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 152.441C295.367 152.831 295.684 153.148 296.074 153.148C296.465 153.148 296.781 152.831 296.781 152.441C296.781 152.05 296.465 151.734 296.074 151.734C295.684 151.734 295.367 152.05 295.367 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 152.441C276.984 152.831 277.301 153.148 277.691 153.148C278.082 153.148 278.398 152.831 278.398 152.441C278.398 152.05 278.082 151.734 277.691 151.734C277.301 151.734 276.984 152.05 276.984 152.441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 170.824C442.431 171.214 442.747 171.531 443.138 171.531C443.528 171.531 443.845 171.214 443.845 170.824C443.845 170.433 443.528 170.117 443.138 170.117C442.747 170.117 442.431 170.433 442.431 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 170.824C424.048 171.214 424.365 171.531 424.755 171.531C425.145 171.531 425.462 171.214 425.462 170.824C425.462 170.433 425.145 170.117 424.755 170.117C424.365 170.117 424.048 170.433 424.048 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 170.824C405.665 171.214 405.982 171.531 406.372 171.531C406.762 171.531 407.079 171.214 407.079 170.824C407.079 170.433 406.762 170.117 406.372 170.117C405.982 170.117 405.665 170.433 405.665 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 170.824C387.282 171.214 387.598 171.531 387.989 171.531C388.379 171.531 388.696 171.214 388.696 170.824C388.696 170.433 388.379 170.117 387.989 170.117C387.598 170.117 387.282 170.433 387.282 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 170.824C368.899 171.214 369.216 171.531 369.606 171.531C369.996 171.531 370.313 171.214 370.313 170.824C370.313 170.433 369.996 170.117 369.606 170.117C369.216 170.117 368.899 170.433 368.899 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 170.824C350.516 171.214 350.833 171.531 351.223 171.531C351.613 171.531 351.93 171.214 351.93 170.824C351.93 170.433 351.613 170.117 351.223 170.117C350.833 170.117 350.516 170.433 350.516 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 170.824C332.133 171.214 332.45 171.531 332.84 171.531C333.231 171.531 333.547 171.214 333.547 170.824C333.547 170.433 333.231 170.117 332.84 170.117C332.45 170.117 332.133 170.433 332.133 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 170.824C313.75 171.214 314.067 171.531 314.457 171.531C314.847 171.531 315.164 171.214 315.164 170.824C315.164 170.433 314.847 170.117 314.457 170.117C314.067 170.117 313.75 170.433 313.75 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 170.824C295.367 171.214 295.684 171.531 296.074 171.531C296.465 171.531 296.781 171.214 296.781 170.824C296.781 170.433 296.465 170.117 296.074 170.117C295.684 170.117 295.367 170.433 295.367 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 170.824C276.984 171.214 277.301 171.531 277.691 171.531C278.082 171.531 278.398 171.214 278.398 170.824C278.398 170.433 278.082 170.117 277.691 170.117C277.301 170.117 276.984 170.433 276.984 170.824Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 189.207C442.431 189.597 442.747 189.914 443.138 189.914C443.528 189.914 443.845 189.597 443.845 189.207C443.845 188.816 443.528 188.5 443.138 188.5C442.747 188.5 442.431 188.816 442.431 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 189.207C424.048 189.597 424.365 189.914 424.755 189.914C425.145 189.914 425.462 189.597 425.462 189.207C425.462 188.816 425.145 188.5 424.755 188.5C424.365 188.5 424.048 188.816 424.048 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 189.207C405.665 189.597 405.982 189.914 406.372 189.914C406.762 189.914 407.079 189.597 407.079 189.207C407.079 188.816 406.762 188.5 406.372 188.5C405.982 188.5 405.665 188.816 405.665 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 189.207C387.282 189.597 387.598 189.914 387.989 189.914C388.379 189.914 388.696 189.597 388.696 189.207C388.696 188.816 388.379 188.5 387.989 188.5C387.598 188.5 387.282 188.816 387.282 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 189.207C368.899 189.597 369.216 189.914 369.606 189.914C369.996 189.914 370.313 189.597 370.313 189.207C370.313 188.816 369.996 188.5 369.606 188.5C369.216 188.5 368.899 188.816 368.899 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 189.207C350.516 189.597 350.833 189.914 351.223 189.914C351.613 189.914 351.93 189.597 351.93 189.207C351.93 188.816 351.613 188.5 351.223 188.5C350.833 188.5 350.516 188.816 350.516 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 189.207C332.133 189.597 332.45 189.914 332.84 189.914C333.231 189.914 333.547 189.597 333.547 189.207C333.547 188.816 333.231 188.5 332.84 188.5C332.45 188.5 332.133 188.816 332.133 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 189.207C313.75 189.597 314.067 189.914 314.457 189.914C314.847 189.914 315.164 189.597 315.164 189.207C315.164 188.816 314.847 188.5 314.457 188.5C314.067 188.5 313.75 188.816 313.75 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 189.207C295.367 189.597 295.684 189.914 296.074 189.914C296.465 189.914 296.781 189.597 296.781 189.207C296.781 188.816 296.465 188.5 296.074 188.5C295.684 188.5 295.367 188.816 295.367 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 189.207C276.984 189.597 277.301 189.914 277.691 189.914C278.082 189.914 278.398 189.597 278.398 189.207C278.398 188.816 278.082 188.5 277.691 188.5C277.301 188.5 276.984 188.816 276.984 189.207Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 207.589C442.431 207.98 442.747 208.296 443.138 208.296C443.528 208.296 443.845 207.98 443.845 207.589C443.845 207.199 443.528 206.882 443.138 206.882C442.747 206.882 442.431 207.199 442.431 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 207.589C424.048 207.98 424.365 208.296 424.755 208.296C425.145 208.296 425.462 207.98 425.462 207.589C425.462 207.199 425.145 206.882 424.755 206.882C424.365 206.882 424.048 207.199 424.048 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 207.589C405.665 207.98 405.982 208.296 406.372 208.296C406.762 208.296 407.079 207.98 407.079 207.589C407.079 207.199 406.762 206.882 406.372 206.882C405.982 206.882 405.665 207.199 405.665 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 207.589C387.282 207.98 387.598 208.296 387.989 208.296C388.379 208.296 388.696 207.98 388.696 207.589C388.696 207.199 388.379 206.882 387.989 206.882C387.598 206.882 387.282 207.199 387.282 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 207.589C368.899 207.98 369.216 208.296 369.606 208.296C369.996 208.296 370.313 207.98 370.313 207.589C370.313 207.199 369.996 206.882 369.606 206.882C369.216 206.882 368.899 207.199 368.899 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 207.589C350.516 207.98 350.833 208.296 351.223 208.296C351.613 208.296 351.93 207.98 351.93 207.589C351.93 207.199 351.613 206.882 351.223 206.882C350.833 206.882 350.516 207.199 350.516 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 207.589C332.133 207.98 332.45 208.296 332.84 208.296C333.231 208.296 333.547 207.98 333.547 207.589C333.547 207.199 333.231 206.882 332.84 206.882C332.45 206.882 332.133 207.199 332.133 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 207.589C313.75 207.98 314.067 208.296 314.457 208.296C314.847 208.296 315.164 207.98 315.164 207.589C315.164 207.199 314.847 206.882 314.457 206.882C314.067 206.882 313.75 207.199 313.75 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 207.589C295.367 207.98 295.684 208.296 296.074 208.296C296.465 208.296 296.781 207.98 296.781 207.589C296.781 207.199 296.465 206.882 296.074 206.882C295.684 206.882 295.367 207.199 295.367 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 207.589C276.984 207.98 277.301 208.296 277.691 208.296C278.082 208.296 278.398 207.98 278.398 207.589C278.398 207.199 278.082 206.882 277.691 206.882C277.301 206.882 276.984 207.199 276.984 207.589Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 225.973C442.431 226.363 442.747 226.68 443.138 226.68C443.528 226.68 443.845 226.363 443.845 225.973C443.845 225.582 443.528 225.266 443.138 225.266C442.747 225.266 442.431 225.582 442.431 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 225.973C424.048 226.363 424.365 226.68 424.755 226.68C425.145 226.68 425.462 226.363 425.462 225.973C425.462 225.582 425.145 225.266 424.755 225.266C424.365 225.266 424.048 225.582 424.048 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 225.973C405.665 226.363 405.982 226.68 406.372 226.68C406.762 226.68 407.079 226.363 407.079 225.973C407.079 225.582 406.762 225.266 406.372 225.266C405.982 225.266 405.665 225.582 405.665 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 225.973C387.282 226.363 387.598 226.68 387.989 226.68C388.379 226.68 388.696 226.363 388.696 225.973C388.696 225.582 388.379 225.266 387.989 225.266C387.598 225.266 387.282 225.582 387.282 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 225.973C368.899 226.363 369.216 226.68 369.606 226.68C369.996 226.68 370.313 226.363 370.313 225.973C370.313 225.582 369.996 225.266 369.606 225.266C369.216 225.266 368.899 225.582 368.899 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 225.973C350.516 226.363 350.833 226.68 351.223 226.68C351.613 226.68 351.93 226.363 351.93 225.973C351.93 225.582 351.613 225.266 351.223 225.266C350.833 225.266 350.516 225.582 350.516 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 225.973C332.133 226.363 332.45 226.68 332.84 226.68C333.231 226.68 333.547 226.363 333.547 225.973C333.547 225.582 333.231 225.266 332.84 225.266C332.45 225.266 332.133 225.582 332.133 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 225.973C313.75 226.363 314.067 226.68 314.457 226.68C314.847 226.68 315.164 226.363 315.164 225.973C315.164 225.582 314.847 225.266 314.457 225.266C314.067 225.266 313.75 225.582 313.75 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 225.973C295.367 226.363 295.684 226.68 296.074 226.68C296.465 226.68 296.781 226.363 296.781 225.973C296.781 225.582 296.465 225.266 296.074 225.266C295.684 225.266 295.367 225.582 295.367 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 225.973C276.984 226.363 277.301 226.68 277.691 226.68C278.082 226.68 278.398 226.363 278.398 225.973C278.398 225.582 278.082 225.266 277.691 225.266C277.301 225.266 276.984 225.582 276.984 225.973Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 244.355C442.431 244.746 442.747 245.063 443.138 245.063C443.528 245.063 443.845 244.746 443.845 244.355C443.845 243.965 443.528 243.648 443.138 243.648C442.747 243.648 442.431 243.965 442.431 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 244.355C424.048 244.746 424.365 245.063 424.755 245.063C425.145 245.063 425.462 244.746 425.462 244.355C425.462 243.965 425.145 243.648 424.755 243.648C424.365 243.648 424.048 243.965 424.048 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 244.355C405.665 244.746 405.982 245.063 406.372 245.063C406.762 245.063 407.079 244.746 407.079 244.355C407.079 243.965 406.762 243.648 406.372 243.648C405.982 243.648 405.665 243.965 405.665 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 244.355C387.282 244.746 387.598 245.063 387.989 245.063C388.379 245.063 388.696 244.746 388.696 244.355C388.696 243.965 388.379 243.648 387.989 243.648C387.598 243.648 387.282 243.965 387.282 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 244.355C368.899 244.746 369.216 245.063 369.606 245.063C369.996 245.063 370.313 244.746 370.313 244.355C370.313 243.965 369.996 243.648 369.606 243.648C369.216 243.648 368.899 243.965 368.899 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 244.355C350.516 244.746 350.833 245.063 351.223 245.063C351.613 245.063 351.93 244.746 351.93 244.355C351.93 243.965 351.613 243.648 351.223 243.648C350.833 243.648 350.516 243.965 350.516 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 244.355C332.133 244.746 332.45 245.063 332.84 245.063C333.231 245.063 333.547 244.746 333.547 244.355C333.547 243.965 333.231 243.648 332.84 243.648C332.45 243.648 332.133 243.965 332.133 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 244.355C313.75 244.746 314.067 245.063 314.457 245.063C314.847 245.063 315.164 244.746 315.164 244.355C315.164 243.965 314.847 243.648 314.457 243.648C314.067 243.648 313.75 243.965 313.75 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 244.355C295.367 244.746 295.684 245.063 296.074 245.063C296.465 245.063 296.781 244.746 296.781 244.355C296.781 243.965 296.465 243.648 296.074 243.648C295.684 243.648 295.367 243.965 295.367 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 244.355C276.984 244.746 277.301 245.063 277.691 245.063C278.082 245.063 278.398 244.746 278.398 244.355C278.398 243.965 278.082 243.648 277.691 243.648C277.301 243.648 276.984 243.965 276.984 244.355Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 262.739C442.431 263.129 442.747 263.446 443.138 263.446C443.528 263.446 443.845 263.129 443.845 262.739C443.845 262.348 443.528 262.031 443.138 262.031C442.747 262.031 442.431 262.348 442.431 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 262.739C424.048 263.129 424.365 263.446 424.755 263.446C425.145 263.446 425.462 263.129 425.462 262.739C425.462 262.348 425.145 262.031 424.755 262.031C424.365 262.031 424.048 262.348 424.048 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 262.739C405.665 263.129 405.982 263.446 406.372 263.446C406.762 263.446 407.079 263.129 407.079 262.739C407.079 262.348 406.762 262.031 406.372 262.031C405.982 262.031 405.665 262.348 405.665 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 262.739C387.282 263.129 387.598 263.446 387.989 263.446C388.379 263.446 388.696 263.129 388.696 262.739C388.696 262.348 388.379 262.031 387.989 262.031C387.598 262.031 387.282 262.348 387.282 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 262.739C368.899 263.129 369.216 263.446 369.606 263.446C369.996 263.446 370.313 263.129 370.313 262.739C370.313 262.348 369.996 262.031 369.606 262.031C369.216 262.031 368.899 262.348 368.899 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 262.739C350.516 263.129 350.833 263.446 351.223 263.446C351.613 263.446 351.93 263.129 351.93 262.739C351.93 262.348 351.613 262.031 351.223 262.031C350.833 262.031 350.516 262.348 350.516 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 262.739C332.133 263.129 332.45 263.446 332.84 263.446C333.231 263.446 333.547 263.129 333.547 262.739C333.547 262.348 333.231 262.031 332.84 262.031C332.45 262.031 332.133 262.348 332.133 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 262.739C313.75 263.129 314.067 263.446 314.457 263.446C314.847 263.446 315.164 263.129 315.164 262.739C315.164 262.348 314.847 262.031 314.457 262.031C314.067 262.031 313.75 262.348 313.75 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 262.739C295.367 263.129 295.684 263.446 296.074 263.446C296.465 263.446 296.781 263.129 296.781 262.739C296.781 262.348 296.465 262.031 296.074 262.031C295.684 262.031 295.367 262.348 295.367 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 262.739C276.984 263.129 277.301 263.446 277.691 263.446C278.082 263.446 278.398 263.129 278.398 262.739C278.398 262.348 278.082 262.031 277.691 262.031C277.301 262.031 276.984 262.348 276.984 262.739Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 281.121C442.431 281.512 442.747 281.828 443.138 281.828C443.528 281.828 443.845 281.512 443.845 281.121C443.845 280.731 443.528 280.414 443.138 280.414C442.747 280.414 442.431 280.731 442.431 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 281.121C424.048 281.512 424.365 281.828 424.755 281.828C425.145 281.828 425.462 281.512 425.462 281.121C425.462 280.731 425.145 280.414 424.755 280.414C424.365 280.414 424.048 280.731 424.048 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 281.121C405.665 281.512 405.982 281.828 406.372 281.828C406.762 281.828 407.079 281.512 407.079 281.121C407.079 280.731 406.762 280.414 406.372 280.414C405.982 280.414 405.665 280.731 405.665 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 281.121C387.282 281.512 387.598 281.828 387.989 281.828C388.379 281.828 388.696 281.512 388.696 281.121C388.696 280.731 388.379 280.414 387.989 280.414C387.598 280.414 387.282 280.731 387.282 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 281.121C368.899 281.512 369.216 281.828 369.606 281.828C369.996 281.828 370.313 281.512 370.313 281.121C370.313 280.731 369.996 280.414 369.606 280.414C369.216 280.414 368.899 280.731 368.899 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 281.121C350.516 281.512 350.833 281.828 351.223 281.828C351.613 281.828 351.93 281.512 351.93 281.121C351.93 280.731 351.613 280.414 351.223 280.414C350.833 280.414 350.516 280.731 350.516 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 281.121C332.133 281.512 332.45 281.828 332.84 281.828C333.231 281.828 333.547 281.512 333.547 281.121C333.547 280.731 333.231 280.414 332.84 280.414C332.45 280.414 332.133 280.731 332.133 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 281.121C313.75 281.512 314.067 281.828 314.457 281.828C314.847 281.828 315.164 281.512 315.164 281.121C315.164 280.731 314.847 280.414 314.457 280.414C314.067 280.414 313.75 280.731 313.75 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 281.121C295.367 281.512 295.684 281.828 296.074 281.828C296.465 281.828 296.781 281.512 296.781 281.121C296.781 280.731 296.465 280.414 296.074 280.414C295.684 280.414 295.367 280.731 295.367 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 281.121C276.984 281.512 277.301 281.828 277.691 281.828C278.082 281.828 278.398 281.512 278.398 281.121C278.398 280.731 278.082 280.414 277.691 280.414C277.301 280.414 276.984 280.731 276.984 281.121Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.431 299.504C442.431 299.895 442.747 300.211 443.138 300.211C443.528 300.211 443.845 299.895 443.845 299.504C443.845 299.114 443.528 298.797 443.138 298.797C442.747 298.797 442.431 299.114 442.431 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.048 299.504C424.048 299.895 424.365 300.211 424.755 300.211C425.145 300.211 425.462 299.895 425.462 299.504C425.462 299.114 425.145 298.797 424.755 298.797C424.365 298.797 424.048 299.114 424.048 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.665 299.504C405.665 299.895 405.982 300.211 406.372 300.211C406.762 300.211 407.079 299.895 407.079 299.504C407.079 299.114 406.762 298.797 406.372 298.797C405.982 298.797 405.665 299.114 405.665 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.282 299.504C387.282 299.895 387.598 300.211 387.989 300.211C388.379 300.211 388.696 299.895 388.696 299.504C388.696 299.114 388.379 298.797 387.989 298.797C387.598 298.797 387.282 299.114 387.282 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.899 299.504C368.899 299.895 369.216 300.211 369.606 300.211C369.996 300.211 370.313 299.895 370.313 299.504C370.313 299.114 369.996 298.797 369.606 298.797C369.216 298.797 368.899 299.114 368.899 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.516 299.504C350.516 299.895 350.833 300.211 351.223 300.211C351.613 300.211 351.93 299.895 351.93 299.504C351.93 299.114 351.613 298.797 351.223 298.797C350.833 298.797 350.516 299.114 350.516 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.133 299.504C332.133 299.895 332.45 300.211 332.84 300.211C333.231 300.211 333.547 299.895 333.547 299.504C333.547 299.114 333.231 298.797 332.84 298.797C332.45 298.797 332.133 299.114 332.133 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 299.504C313.75 299.895 314.067 300.211 314.457 300.211C314.847 300.211 315.164 299.895 315.164 299.504C315.164 299.114 314.847 298.797 314.457 298.797C314.067 298.797 313.75 299.114 313.75 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.367 299.504C295.367 299.895 295.684 300.211 296.074 300.211C296.465 300.211 296.781 299.895 296.781 299.504C296.781 299.114 296.465 298.797 296.074 298.797C295.684 298.797 295.367 299.114 295.367 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.984 299.504C276.984 299.895 277.301 300.211 277.691 300.211C278.082 300.211 278.398 299.895 278.398 299.504C278.398 299.114 278.082 298.797 277.691 298.797C277.301 298.797 276.984 299.114 276.984 299.504Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_32473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.5 19C168.5 17.3431 169.843 16 171.5 16H365.5C367.157 16 368.5 17.3431 368.5 19C368.5 20.6569 367.157 22 365.5 22H171.5C169.843 22 168.5 20.6569 168.5 19Z",
    fill: "#000033",
    fillOpacity: 0.0588235
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 6,
    transform: "translate(168.5 16)",
    fill: "#ABBDF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169 19C169 17.6193 170.119 16.5 171.5 16.5H365.5C366.881 16.5 368 17.6193 368 19C368 20.3807 366.881 21.5 365.5 21.5H171.5C170.119 21.5 169 20.3807 169 19Z",
    stroke: "#00002D",
    strokeOpacity: 0.0901961
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdddii_664_32473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.7915,
    y: 89.04,
    width: 132.864,
    height: 132.864,
    rx: 14.7627,
    fill: "url(#paint0_linear_664_32473)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.486 130.376L147.217 147.107H130.486V163.838L147.217 180.569V163.838H163.948L147.217 147.107H163.948V130.376H130.486Z",
    fill: "#D5DBE3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdddii_664_32473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.375,
    y: 89.04,
    width: 132.864,
    height: 132.864,
    rx: 14.7627,
    fill: "url(#paint1_linear_664_32473)",
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdddii_664_32473)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_32473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.08,
    y: 41.061,
    width: 287.872,
    height: 228.821,
    rx: 14.7627,
    fill: "url(#paint2_linear_664_32473)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.08,
    y: 41.061,
    width: 287.872,
    height: 228.821,
    rx: 14.7627,
    fill: "url(#paint3_linear_664_32473)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.84533,
    height: 228.821,
    transform: "translate(268.093 41.061)",
    fill: "#0E0948",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.093,
    y: 53.9785,
    width: 1.84533,
    height: 94.112,
    rx: 0.922667,
    fill: "url(#paint4_linear_664_32473)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.093,
    y: 196.07,
    width: 1.84533,
    height: 59.0507,
    rx: 0.922667,
    fill: "url(#paint5_linear_664_32473)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_32473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.308 60.4373C139.308 59.9277 138.895 59.5146 138.386 59.5146C137.876 59.5146 137.463 59.9277 137.463 60.4373V62.2826C137.463 62.7922 137.876 63.2053 138.386 63.2053C138.895 63.2053 139.308 62.7922 139.308 62.2826V60.4373Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 75.1998C139.308 74.6902 138.895 74.2771 138.386 74.2771C137.876 74.2771 137.463 74.6902 137.463 75.1998V77.0451C137.463 77.5547 137.876 77.9678 138.386 77.9678C138.895 77.9678 139.308 77.5547 139.308 77.0451V75.1998Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 89.9627C139.308 89.4531 138.895 89.04 138.386 89.04C137.876 89.04 137.463 89.4531 137.463 89.9627V91.808C137.463 92.3176 137.876 92.7307 138.386 92.7307C138.895 92.7307 139.308 92.3176 139.308 91.808V89.9627Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 104.725C139.308 104.216 138.895 103.802 138.386 103.802C137.876 103.802 137.463 104.216 137.463 104.725V106.57C137.463 107.08 137.876 107.493 138.386 107.493C138.895 107.493 139.308 107.08 139.308 106.57V104.725Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 119.488C139.308 118.978 138.895 118.565 138.386 118.565C137.876 118.565 137.463 118.978 137.463 119.488V121.333C137.463 121.843 137.876 122.256 138.386 122.256C138.895 122.256 139.308 121.843 139.308 121.333V119.488Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 134.251C139.308 133.741 138.895 133.328 138.386 133.328C137.876 133.328 137.463 133.741 137.463 134.251V136.096C137.463 136.606 137.876 137.019 138.386 137.019C138.895 137.019 139.308 136.606 139.308 136.096V134.251Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 149.013C139.308 148.504 138.895 148.091 138.386 148.091C137.876 148.091 137.463 148.504 137.463 149.013V150.859C137.463 151.368 137.876 151.781 138.386 151.781C138.895 151.781 139.308 151.368 139.308 150.859V149.013Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 163.776C139.308 163.266 138.895 162.853 138.386 162.853C137.876 162.853 137.463 163.266 137.463 163.776V165.621C137.463 166.131 137.876 166.544 138.386 166.544C138.895 166.544 139.308 166.131 139.308 165.621V163.776Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.308 178.539C139.308 178.029 138.895 177.616 138.386 177.616C137.876 177.616 137.463 178.029 137.463 178.539V180.384C137.463 180.894 137.876 181.307 138.386 181.307C138.895 181.307 139.308 180.894 139.308 180.384V178.539Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.215 74.2771H152.226C151.207 74.2771 150.38 75.1033 150.38 76.1224C150.38 77.1416 151.207 77.9678 152.226 77.9678H176.215C177.234 77.9678 178.06 77.1416 178.06 76.1224C178.06 75.1033 177.234 74.2771 176.215 74.2771Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.978 74.2771H185.442C184.422 74.2771 183.596 75.1033 183.596 76.1224C183.596 77.1416 184.422 77.9678 185.442 77.9678H190.978C191.997 77.9678 192.823 77.1416 192.823 76.1224C192.823 75.1033 191.997 74.2771 190.978 74.2771Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.276 74.2771H200.204C199.185 74.2771 198.359 75.1033 198.359 76.1224C198.359 77.1416 199.185 77.9678 200.204 77.9678H211.276C212.295 77.9678 213.122 77.1416 213.122 76.1224C213.122 75.1033 212.295 74.2771 211.276 74.2771Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.442 103.802H166.988C165.969 103.802 165.143 104.629 165.143 105.648C165.143 106.667 165.969 107.493 166.988 107.493H185.442C186.461 107.493 187.287 106.667 187.287 105.648C187.287 104.629 186.461 103.802 185.442 103.802Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.121 103.802H194.668C193.649 103.802 192.823 104.629 192.823 105.648C192.823 106.667 193.649 107.493 194.668 107.493H213.121C214.141 107.493 214.967 106.667 214.967 105.648C214.967 104.629 214.141 103.802 213.121 103.802Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.492 103.802H222.348C221.329 103.802 220.503 104.629 220.503 105.648C220.503 106.667 221.329 107.493 222.348 107.493H244.492C245.511 107.493 246.338 106.667 246.338 105.648C246.338 104.629 245.511 103.802 244.492 103.802Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.564 103.802H253.719C252.7 103.802 251.874 104.629 251.874 105.648C251.874 106.667 252.7 107.493 253.719 107.493H255.564C256.583 107.493 257.41 106.667 257.41 105.648C257.41 104.629 256.583 103.802 255.564 103.802Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.452 59.5146H152.226C151.207 59.5146 150.38 60.3408 150.38 61.36C150.38 62.3791 151.207 63.2053 152.226 63.2053H161.452C162.472 63.2053 163.298 62.3791 163.298 61.36C163.298 60.3408 162.472 59.5146 161.452 59.5146Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.215 59.5146H170.679C169.66 59.5146 168.833 60.3408 168.833 61.36C168.833 62.3791 169.66 63.2053 170.679 63.2053H176.215C177.234 63.2053 178.06 62.3791 178.06 61.36C178.06 60.3408 177.234 59.5146 176.215 59.5146Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.194 59.5146H185.442C184.422 59.5146 183.596 60.3408 183.596 61.36C183.596 62.3791 184.422 63.2053 185.442 63.2053H224.194C225.213 63.2053 226.039 62.3791 226.039 61.36C226.039 60.3408 225.213 59.5146 224.194 59.5146Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74 89.04H166.988C165.969 89.04 165.143 89.8662 165.143 90.8854C165.143 91.9045 165.969 92.7307 166.988 92.7307H205.74C206.76 92.7307 207.586 91.9045 207.586 90.8854C207.586 89.8662 206.76 89.04 205.74 89.04Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.42 89.04H214.967C213.948 89.04 213.122 89.8662 213.122 90.8854C213.122 91.9045 213.948 92.7307 214.967 92.7307H233.42C234.439 92.7307 235.266 91.9045 235.266 90.8854C235.266 89.8662 234.439 89.04 233.42 89.04Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.719 89.04H242.647C241.627 89.04 240.801 89.8662 240.801 90.8854C240.801 91.9045 241.627 92.7307 242.647 92.7307H253.719C254.738 92.7307 255.564 91.9045 255.564 90.8854C255.564 89.8662 254.738 89.04 253.719 89.04Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.442 118.565H178.06C177.041 118.565 176.215 119.391 176.215 120.411C176.215 121.43 177.041 122.256 178.06 122.256H185.442C186.461 122.256 187.287 121.43 187.287 120.411C187.287 119.391 186.461 118.565 185.442 118.565Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.121 118.565H194.668C193.649 118.565 192.823 119.391 192.823 120.411C192.823 121.43 193.649 122.256 194.668 122.256H213.121C214.141 122.256 214.967 121.43 214.967 120.411C214.967 119.391 214.141 118.565 213.121 118.565Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.039 118.565H222.348C221.329 118.565 220.503 119.391 220.503 120.411C220.503 121.43 221.329 122.256 222.348 122.256H226.039C227.058 122.256 227.884 121.43 227.884 120.411C227.884 119.391 227.058 118.565 226.039 118.565Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.183 118.565H235.266C234.247 118.565 233.42 119.391 233.42 120.411C233.42 121.43 234.247 122.256 235.266 122.256H248.183C249.202 122.256 250.028 121.43 250.028 120.411C250.028 119.391 249.202 118.565 248.183 118.565Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.298 133.328H152.226C151.207 133.328 150.38 134.154 150.38 135.173C150.38 136.193 151.207 137.019 152.226 137.019H163.298C164.317 137.019 165.143 136.193 165.143 135.173C165.143 134.154 164.317 133.328 163.298 133.328Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06 133.328H172.524C171.505 133.328 170.679 134.154 170.679 135.173C170.679 136.193 171.505 137.019 172.524 137.019H178.06C179.079 137.019 179.905 136.193 179.905 135.173C179.905 134.154 179.079 133.328 178.06 133.328Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.729 133.328H187.287C186.268 133.328 185.441 134.154 185.441 135.173C185.441 136.193 186.268 137.019 187.287 137.019H229.729C230.749 137.019 231.575 136.193 231.575 135.173C231.575 134.154 230.749 133.328 229.729 133.328Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.802 133.328H238.956C237.937 133.328 237.111 134.154 237.111 135.173C237.111 136.193 237.937 137.019 238.956 137.019H240.802C241.821 137.019 242.647 136.193 242.647 135.173C242.647 134.154 241.821 133.328 240.802 133.328Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.298 162.853H152.226C151.207 162.853 150.38 163.679 150.38 164.698C150.38 165.718 151.207 166.544 152.226 166.544H163.298C164.317 166.544 165.143 165.718 165.143 164.698C165.143 163.679 164.317 162.853 163.298 162.853Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.668 162.853H172.524C171.505 162.853 170.679 163.679 170.679 164.698C170.679 165.718 171.505 166.544 172.524 166.544H194.668C195.687 166.544 196.513 165.718 196.513 164.698C196.513 163.679 195.687 162.853 194.668 162.853Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.431 162.853H203.895C202.876 162.853 202.049 163.679 202.049 164.698C202.049 165.718 202.876 166.544 203.895 166.544H209.431C210.45 166.544 211.276 165.718 211.276 164.698C211.276 163.679 210.45 162.853 209.431 162.853Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.266 162.853H218.658C217.639 162.853 216.812 163.679 216.812 164.698C216.812 165.718 217.639 166.544 218.658 166.544H235.266C236.285 166.544 237.111 165.718 237.111 164.698C237.111 163.679 236.285 162.853 235.266 162.853Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.442 148.091H166.988C165.969 148.091 165.143 148.917 165.143 149.936C165.143 150.955 165.969 151.781 166.988 151.781H185.442C186.461 151.781 187.287 150.955 187.287 149.936C187.287 148.917 186.461 148.091 185.442 148.091Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74 148.091H194.668C193.649 148.091 192.823 148.917 192.823 149.936C192.823 150.955 193.649 151.781 194.668 151.781H205.74C206.759 151.781 207.585 150.955 207.585 149.936C207.585 148.917 206.759 148.091 205.74 148.091Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.111 148.091H214.967C213.948 148.091 213.122 148.917 213.122 149.936C213.122 150.955 213.948 151.781 214.967 151.781H237.111C238.13 151.781 238.956 150.955 238.956 149.936C238.956 148.917 238.13 148.091 237.111 148.091Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.183 148.091H246.338C245.318 148.091 244.492 148.917 244.492 149.936C244.492 150.955 245.318 151.781 246.338 151.781H248.183C249.202 151.781 250.028 150.955 250.028 149.936C250.028 148.917 249.202 148.091 248.183 148.091Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.758 52.981H289.917C286.017 52.981 282.855 56.1427 282.855 60.0428V120.291C282.855 124.191 286.017 127.352 289.917 127.352H328.758C332.658 127.352 335.819 124.191 335.819 120.291V60.0428C335.819 56.1427 332.658 52.981 328.758 52.981Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53 131.353H292.145C291.319 131.353 290.65 132.179 290.65 133.198C290.65 134.217 291.319 135.043 292.145 135.043H326.53C327.356 135.043 328.025 134.217 328.025 133.198C328.025 132.179 327.356 131.353 326.53 131.353Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.758 148.091H289.917C286.017 148.091 282.855 151.252 282.855 155.152V215.4C282.855 219.3 286.017 222.462 289.917 222.462H328.758C332.658 222.462 335.819 219.3 335.819 215.4V155.152C335.819 151.252 332.658 148.091 328.758 148.091Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53 226.462H292.145C291.319 226.462 290.65 227.288 290.65 228.307C290.65 229.327 291.319 230.153 292.145 230.153H326.53C327.356 230.153 328.025 229.327 328.025 228.307C328.025 227.288 327.356 226.462 326.53 226.462Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.784 52.981H348.944C345.044 52.981 341.882 56.1427 341.882 60.0428V120.291C341.882 124.191 345.044 127.352 348.944 127.352H387.784C391.684 127.352 394.846 124.191 394.846 120.291V60.0428C394.846 56.1427 391.684 52.981 387.784 52.981Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.557 131.353H351.171C350.346 131.353 349.676 132.179 349.676 133.198C349.676 134.217 350.346 135.043 351.171 135.043H385.557C386.382 135.043 387.052 134.217 387.052 133.198C387.052 132.179 386.382 131.353 385.557 131.353Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.784 148.091H348.944C345.044 148.091 341.882 151.252 341.882 155.152V215.4C341.882 219.3 345.044 222.462 348.944 222.462H387.784C391.684 222.462 394.846 219.3 394.846 215.4V155.152C394.846 151.252 391.684 148.091 387.784 148.091Z",
    fill: "#22328A",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.557 226.462H351.171C350.346 226.462 349.676 227.288 349.676 228.307C349.676 229.327 350.346 230.153 351.171 230.153H385.557C386.382 230.153 387.052 229.327 387.052 228.307C387.052 227.288 386.382 226.462 385.557 226.462Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_664_32473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.872,
    y: 133.328,
    width: 44.288,
    height: 44.288,
    rx: 22.144,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_32473)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_664_32473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.057 150.897C273.057 150.451 272.696 150.089 272.25 150.089C271.804 150.089 271.442 150.451 271.442 150.897C271.442 153.508 270.866 155.204 269.809 156.26C268.753 157.317 267.057 157.894 264.446 157.894C264 157.894 263.638 158.255 263.638 158.701C263.638 159.147 264 159.508 264.446 159.508C267.057 159.508 268.753 160.085 269.809 161.142C270.866 162.198 271.442 163.894 271.442 166.505C271.442 166.951 271.804 167.313 272.25 167.313C272.696 167.313 273.057 166.951 273.057 166.505C273.057 163.894 273.634 162.198 274.69 161.142C275.747 160.085 277.443 159.508 280.054 159.508C280.5 159.508 280.861 159.147 280.861 158.701C280.861 158.255 280.5 157.894 280.054 157.894C277.443 157.894 275.747 157.317 274.69 156.26C273.634 155.204 273.057 153.508 273.057 150.897Z",
    fill: "url(#paint6_linear_664_32473)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.907 144.437C263.907 143.992 263.546 143.63 263.1 143.63C262.654 143.63 262.293 143.992 262.293 144.437C262.293 146.114 261.922 147.137 261.304 147.755C260.687 148.372 259.664 148.743 257.987 148.743C257.541 148.743 257.18 149.105 257.18 149.551C257.18 149.996 257.541 150.358 257.987 150.358C259.664 150.358 260.687 150.729 261.304 151.346C261.922 151.964 262.293 152.987 262.293 154.664C262.293 155.11 262.654 155.471 263.1 155.471C263.546 155.471 263.907 155.11 263.907 154.664C263.907 152.987 264.279 151.964 264.896 151.346C265.513 150.729 266.536 150.358 268.213 150.358C268.659 150.358 269.021 149.996 269.021 149.551C269.021 149.105 268.659 148.743 268.213 148.743C266.536 148.743 265.513 148.372 264.896 147.755C264.279 147.137 263.907 146.114 263.907 144.437Z",
    fill: "url(#paint7_linear_664_32473)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdddii_664_32473",
    x: 36.5035,
    y: 59.5147,
    width: 221.44,
    height: 221.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.22667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.7627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32473",
    result: "effect2_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84533
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84533
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32473",
    result: "effect3_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.84533,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32473",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32473",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.536
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.768
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.461333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32473",
    result: "effect6_innerShadow_664_32473"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdddii_664_32473",
    x: 280.087,
    y: 59.5147,
    width: 221.44,
    height: 221.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.22667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.7627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32473",
    result: "effect2_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84533
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84533
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32473",
    result: "effect3_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.84533,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32473",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32473",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.536
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.768
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.461333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32473",
    result: "effect6_innerShadow_664_32473"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdddii_664_32473",
    x: 80.7916,
    y: 11.5357,
    width: 376.448,
    height: 317.397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.22667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.7627
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.144
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_32473",
    result: "effect2_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84533
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84533
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_32473",
    result: "effect3_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.84533,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_32473",
    result: "effect4_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_32473",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5.536
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.768
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.072
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.461333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_32473",
    result: "effect6_innerShadow_664_32473"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_664_32473",
    x: 243.181,
    y: 131.483,
    width: 51.6694,
    height: 51.6694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.84533,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84533
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.84533
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_32473",
    result: "effect2_dropShadow_664_32473"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_32473",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_32473",
    x1: 147.224,
    y1: 89.04,
    x2: 147.224,
    y2: 221.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_32473",
    x1: 390.808,
    y1: 89.04,
    x2: 390.808,
    y2: 221.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_32473",
    x1: 269.016,
    y1: 41.061,
    x2: 269.016,
    y2: 269.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_32473",
    x1: 125.08,
    y1: 155.472,
    x2: 412.952,
    y2: 155.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#F3F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_32473",
    x1: 269.015,
    y1: 53.9785,
    x2: 269.015,
    y2: 148.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B76E1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B71E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_32473",
    x1: 269.015,
    y1: 196.07,
    x2: 269.015,
    y2: 255.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B71E1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B78E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_32473",
    x1: 269.02,
    y1: 143.631,
    x2: 274.556,
    y2: 172.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_32473",
    x1: 269.021,
    y1: 143.63,
    x2: 274.556,
    y2: 172.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_32473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350.69,
    height: 240.392,
    fill: "white",
    transform: "translate(93.1548 78.2019)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_32473"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.5 19C168.5 17.3431 169.843 16 171.5 16H365.5C367.157 16 368.5 17.3431 368.5 19C368.5 20.6569 367.157 22 365.5 22H171.5C169.843 22 168.5 20.6569 168.5 19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_32473"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.08,
    y: 41.061,
    width: 287.872,
    height: 228.821,
    rx: 14.7627,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_32473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.947,
    height: 121.792,
    fill: "white",
    transform: "translate(137.463 59.5146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_32473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.68,
    height: 25.8347,
    fill: "white",
    transform: "translate(255.176 142.555)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_664_32473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.68,
    height: 25.8347,
    fill: "white",
    transform: "translate(255.176 142.555)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.66b305c862f74fb95dfe304ed773254b.svg";
export { ForwardRef as ReactComponent };